<template>
  <svg fill="none" height="15" viewBox="0 0 18 15" width="18">
    <path
      d="M17 8H11.8L10.4 9.9375H7.59999L6.19994 8H0.999939M17 8V12.375C17 12.806 16.8525 13.2193 16.5899 13.524C16.3274 13.8288 15.9713 14 15.6 14H2.39999C2.02868 14 1.67259 13.8288 1.41004 13.524C1.14749 13.2193 0.999988 12.806 0.999988 12.375L0.999939 8M17 8L13.585 1.90188C13.4691 1.63114 13.2904 1.4033 13.0691 1.24398C12.8477 1.08465 12.5924 1.00016 12.332 1H5.66799C5.40753 1.00016 5.15227 1.08465 4.93092 1.24398C4.70957 1.4033 4.53089 1.63114 4.41499 1.90188L0.999939 8"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'DrawerIcon',
  };
</script>

